module.exports = __webpack_public_path__ + "static/media/thestir.cafemom.com_pregnancy_196854_14_baby_names_voted_the_plot.eps.5c80d919.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/thestir.cafemom.com_pregnancy_196854_14_baby_names_voted_the_plot.eps.png
// module id = 425
// module chunks = 0